// extracted by mini-css-extract-plugin
module.exports = {"container_two":"home_container_two__2C2zN","data_wrapper":"home_data_wrapper__2XduY","mode_bup_wrapper":"home_mode_bup_wrapper__2SSev","title":"home_title__MaaWF"};